module.exports = __webpack_public_path__ + "img/illustration_approval.59577e5e.svg";